
import defaultSettings from '@/setting'

const {theZcBookPreviewUrl,theJcBookPreviewUrl,theRedirectBookPreviewUrl,theBusinessUrl,websiteDefaultVersion } = defaultSettings

const state = {
    theZcBookPreviewUrl:theZcBookPreviewUrl,
    theJcBookPreviewUrl:theJcBookPreviewUrl,
    theRedirectBookPreviewUrl,
    theBusinessUrl: theBusinessUrl,
    currentVersion: websiteDefaultVersion,
}
const mutations = {
    CANGE_CURRENTVERSION:(state,val) =>{
        state.currentVersion = val
        // localStorage.setItem('currentVersion',val)
    }
}


export default {
    namespaced: true,
    state,
    mutations
}

